import { AnyObject } from 'final-form';
import React from 'react';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import { UseFormMethods } from 'react-hook-form';
import AcknowledgementType from 'src/models/leasing/AcknowledgementType';
import Card from 'src/components/common/Card.redesign';
import { ContextMenuAction } from 'src/components/common/ContextMenu';
import '../../../../../common/styles/hover-highlight.scss';
interface ISignatureCard extends Partial<Pick<UseFormMethods, 'register' | 'errors'>> {
    signatureInfo?: AnyObject;
    name?: string;
    ackType?: AcknowledgementType[];
    typeSelected?: number;
    index?: number;
    pop?: (index: number) => void;
    deleteCard?: (index: number) => void;
}

const SignatureCard: React.FC<ISignatureCard> = (props) => {
    const actions: ContextMenuAction[] = [{ text: 'Delete Signature', action: () => props?.deleteCard(props.index) }];

    return (
        <Card
            className="card-highlight"
            badge={`${props.index + 1}`}
            key={props.index}
            contextActions={actions}
            newContext={true}
            showMenu={true}
            style={{
                display: 'flex',
                justifyContent: 'space-around',
                border: '2px solid #ccc',
                padding: '1rem',
                borderRadius: '5px',
                margin: '1rem 1rem 0 1rem',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    gap: '5rem',
                    alignItems: 'center',
                }}
            >
                <input type="hidden" name={`signatureBlocks[${props?.index}].id`} ref={props.register} />
                <input type="hidden" name={`signatureBlocks[${props?.index}].acknowledgementId`} ref={props.register} />
                <RHFInputBox label="Owner" name={`signatureBlocks[${props?.index}].ownerName`} register={props.register} style={{ width: '150px' }} />

                <RHFInputBox label="Title" name={`signatureBlocks[${props?.index}].title`} register={props.register} style={{ width: '150px' }} />
            </div>
        </Card>
    );
};

export default SignatureCard;



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/redesign/SignatureBlockComponents/SignatureCard.redesign.tsx